import { useState, useCallback } from 'react';

interface UnsavedChangesState {
    [tabName: string]: boolean;
}

export const useUnsavedChanges = () => {
    const [unsavedChanges, setUnsavedChanges] = useState<UnsavedChangesState>({});

    const setTabHasUnsavedChanges = useCallback((tabName: string, hasChanges: boolean) => {
        setUnsavedChanges(prev => ({
            ...prev,
            [tabName]: hasChanges
        }));
    }, []);

    const hasAnyUnsavedChanges = useCallback(() => {
        return Object.values(unsavedChanges).some(hasChanges => hasChanges);
    }, [unsavedChanges]);

    const clearAllUnsavedChanges = useCallback(() => {
        setUnsavedChanges({});
    }, []);

    const getTabsWithUnsavedChanges = useCallback(() => {
        return Object.keys(unsavedChanges).filter(tabName => unsavedChanges[tabName]);
    }, [unsavedChanges]);

    return {
        setTabHasUnsavedChanges,
        hasAnyUnsavedChanges,
        clearAllUnsavedChanges,
        getTabsWithUnsavedChanges,
        unsavedChanges
    };
};